import { AxiosPromise } from 'axios';
import { axios } from 'src/app/utils';
import { finalUrlsConfig } from 'src/configs/url.config';
import { InterestsTypes } from 'src/enums/interests.enum';

const getUrl = (interestType: InterestsTypes) => {
  let url = '';

  switch (interestType) {
    case InterestsTypes.Location:
      url = finalUrlsConfig().interest.identified.location.lookup;
      break;

    case InterestsTypes.Person:
      url = finalUrlsConfig().interest.identified.person.lookup;
      break;

    case InterestsTypes.Vehicle:
      url = finalUrlsConfig().interest.identified.vehicle.lookup;
      break;

    default:
      break;
  }

  return url;
};

export const getImagesOfInterest = (query: {
  id: string;
  interestType: InterestsTypes;
}): AxiosPromise<{ filename: string; data: any }[]> | { data: [] } => {
  const url = getUrl(query.interestType);
  if (!url) return { data: [] };

  return axios.get(`${url}/images/${query.id}`, {
    params: query,
  });
};

export const removeImage = (query: { photoName: string; interestType: InterestsTypes }) => {
  const url = getUrl(query.interestType);
  if (!url) return;

  return axios.post(`${url}/deletePhotoFromCache`, {
    photoName: query.photoName,
  });
};
